import { render, staticRenderFns } from "./IconAction.vue?vue&type=template&id=66e9e142&"
import script from "./IconAction.vue?vue&type=script&lang=ts&"
export * from "./IconAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports